module.exports = __webpack_public_path__ + "static/media/address_image.bdf3dfdf.svg";